import request from '@/utils/request'

/*
 *  账号密码登录
 */
export function authLogin (data) {
  return request.request(
    `/auth/authenticate`,
    data,
    {method: 'POST'}
  )
}/*
 *  账号密码登录
 */
export function guestRegister (data) {
  return request.request(
    `/guest`,
    data,
    {method: 'POST'}
  )
}

/*
 *  账号密码注册
 */
export function authRegister (data) {
  return request.request(
    `/auth/signup`,
    data,
    {method: 'POST'}
  )
}

/*
 *  账号退出登录
 */
export function authLogout () {
  return request.request(
    `/auth/logout`,
    {device: 'wap'},
    {method: 'POST'}
  )
}

/*
 * 查询用户信息
 */
export function fetchUser () {
  return request.request(
    `/personal/profile`,
    {},
    {method: 'get'}
  )
}

/*
 * 查询订单状态数量信息
 */
export function fetchOrderStatus () {
  return request.request(
    `/personal/transaction_stat`,
    {},
    {method: 'get'}
  )
}

/*
 * 查询客户经理信息
 */
export function fetchCustomerService () {
  return request.request(
    `/personal/customer_service`,
    {},
    {method: 'get'}
  )
}

/*
 * 修改用户信息
 *
 {
 name: vm.name,
 email: vm.email,
 qq: vm.qq,
 company_site: vm.company_site,
 company_name: vm.company_name,
 company_address: vm.company_address
 }
 *
 *
 *
 */
export function editUserInfo (params) {
  return request.request(
    `/personal/profile`,
    params,
    {method: 'post'}
  )
}

/*
 * 修改密码
 */
export function changePassword (params) {
  return request.request(
    `/auth/reset_password`,
    params,
    {method: 'post'}
  )
}

/*
 * 通过微信code获取token，没有token会返回{openid，session_key，unionid}，
 * */
export function authToken (code) {
  return request.request(
    `/connect/wx_lite/login`,
    {code},
    {method: 'get'}
  )
}

/*
 *  通过获取手机号码getphonenumber登录，如果用户不存在，系统将会自动创建用户。验证成功后，会返回token
 * */

export function authPhoneNumRegister (data) {
  return request.request(
    `/connect/wx_lite/authenticate`,
    data,
    {method: 'post'}
  )
}

/*
 *  获取交易流水
 * */

export function getFinanceTransaction (page) {
  return request.request(
    `/finance/transaction`,
    {
      page,
      status: 'success'
    },
    {method: 'get'}
  )
}

/*
 *  获取充值记录
 * */

export function getRechargeHistory (page) {
  return request.request(
    `/finance/recharge`,
    {
      page,
      status: 'success'
    },
    {method: 'get'}
  )
}

/*
 *  获取退款记录
 * */

export function getRefundHistory (page) {
  return request.request(
    `/finance/refund`,
    {
      page
    },
    {method: 'get'}
  )
}

/*
 *  获取消费记录
 * */

export function getConsumeHistory (page) {
  return request.request(
    `/finance/consume`,
    {
      page
    },
    {method: 'get'}
  )
}

/*
 *  authShake接口，获取用户状态
 * */

export function authShake () {
  return request.request(
    `/auth/shake`,
    {},
    {method: 'get'}
  )
}

/*
 *  获取行业列表
 * */

export function getIndustryList () {
  return request.request(
    `/basic_data/industry?scope=all`,
    {},
    {method: 'get'}
  )
}



// WEBPACK FOOTER //
// ./src/api/user.js